/**
 * !!!! Read me !!!!
 * ทำขึ้นเพื่อจัดการ route path ไม่ให้มองเห็น id หรือ key ต่างๆ ที่ต้องการส่งข้ามหน้ากัน
 * เช่นของเดิม route path เป็น /FormG01?Ref=1 เพื่อไม่ให้เห็น Ref ที่ส่งมา และป้องกันการแก้ไข id
 * จาก url เลยใช้ vuex store เข้ามาช่วยจัดการ state
 * state — คือ object ที่ใช้เก็บข้อมูลที่เราต้องการ
 * mutations — คือ ตัวที่จะค่อยไปแก้ไขข้อมูล state
 * actions — คือ ฟังก์ชันที่จะทำการ calculate หรือทำ logic ต่างๆ เพื่อจะได้ผลลัพท์ที่ต้องการ จากนั้นก็จะบอกให้ mutations ไปแก้ไขข้อมูลที่ state
 */
import { StateFormDiPromMutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { useRouter } from "vue-router";

export interface Params {
  // ref : แล้วแต่จะใช้ ส่วนมากจะใช้เก็บ id ที่แก้ไข
  g01Id: number;
  g01_1Id: number;
  g01ViewOnly: boolean;
  g01_1ViewOnly: boolean;
}

export interface ParamsInfo {
  params: Params;
}

@Module
export default class StateFormDiPromModule
  extends VuexModule
  implements ParamsInfo
{
  params = {} as Params;

  //#region Form G01

  get getCurrentStateG01Id(): number {
    const router = useRouter();
    if (!this.params.g01Id && this.params.g01Id != 0) {
      router.push({
        path: "/FormG",
      });
    }
    return this.params.g01Id;
  }

  get getCurrentStateG01ViewOnly(): boolean {
    return this.params.g01ViewOnly;
  }

  @Mutation
  [StateFormDiPromMutations.SET_G01_ID](param) {
    this.params.g01Id = param.id;
    this.params.g01ViewOnly = param.viewOnly;
  }

  //   ยังไม่ได้ใช้เพราะไม่มี logic อะไร นอกจากแค่ set ค่า key ปัจจุุบัน ใช้แค่ mutatuin ก็ได้
  //   @Action
  //   [Actions.EDIT_G01](id) {
  //     this.context.commit(Mutations.SET_G01_ID, id);
  //   }

  //#endregion

  //#region Form G01-1
  get getCurrentStateG01_1Id(): number {
    const router = useRouter();
    if (!this.params.g01_1Id && this.params.g01_1Id != 0) {
      router.push({
        path: "/FormG",
        query: { Ref: "G01-1" },
      });
    }
    return this.params.g01_1Id;
  }

  get getCurrentStateG01_1ViewOnly(): boolean {
    return this.params.g01_1ViewOnly;
  }

  @Mutation
  [StateFormDiPromMutations.SET_G01_1_ID](param) {
    this.params.g01_1Id = param.id;
    this.params.g01_1ViewOnly = param.viewOnly;
  }
  //#endregion
}
